<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import DishCardContainer from './dishCardContainer.vue'
import Loader from '@/components/widgets/loader'
import DeleteDishModal from './deleteDishModal.vue'
import IsActiveDishModal from './isActiveDishModal.vue'
import DishCategorySort from './dishCategorySort.vue'
import { apiService } from '@/helpers/api.service'
import Swal from 'sweetalert2'
import { saveAs } from 'file-saver';
import { permissionsMap, checkPermission } from '@/utils/utilsPermissions';


export default {
    components: { Layout, PageHeader, Loader, DeleteDishModal, IsActiveDishModal, DishCardContainer, DishCategorySort },
    props: {
    },
    data() {
        return {
            loading: true,
            selectedDish: null,
            categories: [],
            file: null,
            selectedFile: null,
            selectedFileName: '',
            plateNames: [],
            templateUrl: `${process.env.VUE_APP_CONTENT_URL}/resto/template-platos-welly.xlsx`,
            uploading: false
        };
    },
    mounted() {
        this.getDishes()
        this.canChangeCategory()
        this.canAddDish()
        this.canDownloadTemplate()
    },
    computed: {
        storeHasDishes() {
            return this.categories.some(category => category.dishes && category.dishes.length > 0)
        },
    },
    methods: {
        canChangeCategory() {
            return checkPermission(permissionsMap.UPDATE_OWN_STORE_CATEGORY, this.$store.state.permissions)
        },
        canAddDish() {
            return checkPermission(permissionsMap.CREATE_OWN_STORE_PRODUCT, this.$store.state.permissions)
        },
        canDownloadTemplate() {
            return checkPermission(permissionsMap.READ_STORE_PRODUCT_ID, this.$store.state.permissions)
        },
        handleTemplateDownload() {
            if (this.storeHasDishes) {
                Swal.fire({
                    icon: 'info',
                    iconColor: '#2DA673',
                    title: 'Plantilla no disponible',
                    text: 'Tu tienda ya tiene platos cargados. Para agregar o editar tus platos actuales, utilizá el botón "Exportar platos".',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#2DA673',
                })
                return
            }
            const link = document.createElement('a')
            link.href = this.templateUrl
            link.download = 'plantilla_platos.xlsx'
            link.click()
        },
        showAlert(success) {
            Swal.fire({
                icon: success ? "success" : "error",
                title: success ? "Platos descargados correctamente" : "Error al descargar platos",
                showConfirmButton: false,
                timer: 4500,
            });
        },
        downloadTemplate() {
            apiService.downloadTemplate()
                .then((res) => {
                    if (res) {
                        const buffer = res.data
                        saveAs(buffer, 'platos.xls')
                        this.showAlert(true);
                        return
                    } 
                    else {
                        this.showAlert(false);
                        return
                    }

                }).catch(() => {
                    this.showAlert(false);
                })
        },
        getDishes() {
            apiService.getStoreById()
                .then((res) => {
                    this.categories = res.categories
                    this.closeLoading()
                })
        },
        closeLoading() {
            this.loading = false
        },
        openDeleteDishModal(dish) {
            this.selectedDish = dish
            this.$bvModal.show('deleteDish')
        },
        openIsAsctiveDishModal(dish) {
            this.selectedDish = dish
            this.$bvModal.show('isActiveDish')
        },
        deleteDish(dish) {
            let removeCategoryIndex = -1;
            let removeDishIndex = -1;

            for (const [categoryIndex, category] of this.categories.entries()) {
                const dishes = category.dishes;
                const dishIndex = dishes.findIndex(item => item._id === dish._id);

                if (dishIndex !== -1) {
                    removeCategoryIndex = categoryIndex;
                    removeDishIndex = dishIndex;
                    break;
                }
            }

            if (removeCategoryIndex !== -1 && removeDishIndex !== -1) {
                this.categories[removeCategoryIndex].dishes.splice(removeDishIndex, 1);
            }
        },
        openEdit(dish) {
            this.$router.push(`/welly/my-dishes/edit-dish/${dish._id}`)
        },
        openSortCategories() {
            this.$bvModal.show('dishCategorySort')
        },
        openLoadDishes() {
            this.$bvModal.show('loadDishes');
        },
        reloadDishes() {
            this.loading = true
            this.getDishes()
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileSelection(event) {
            const fileInput = event.target;
            if (fileInput.files.length > 0) {
                this.selectedFile = fileInput.files[0];
                this.selectedFileName = this.selectedFile.name;
            }
        },
        async handleFileAction() {
            console.log('[handleFileAction] selectedFile:', this.selectedFile);
            if (!this.selectedFile) {
                this.triggerFileInput();
            } else {
                const validExtensions = ['.xls', '.xlsx'];
                const fileName = this.selectedFile.name.toLowerCase();
                const isValid = validExtensions.some(ext => fileName.endsWith(ext));
                if (!isValid) {
                    Swal.fire({
                        icon: 'error',
                        iconColor: '#2DA673',
                        title: 'Formato no válido',
                        text: 'Solo se permiten archivos con formato Excel (.xls, .xlsx).',
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#2DA673',
                    });
                    this.selectedFile = null;
                    this.selectedFileName = '';
                    return;
                }
                await this.triggerFileUpload();
            }
        },

        async triggerFileUpload() {
            if (!this.selectedFile) {
                console.error('No se ha seleccionado ningún archivo')
                return
            }

            this.uploading = true

            try {
                const formData = new FormData()
                formData.append('file', this.selectedFile)

                const response = await apiService.importDishesFromFile(formData)
                const { created, updated, errors } = response.data

                let message = ''
                if (created > 0) message += `${created} plato${created !== 1 ? 's' : ''} creado${created !== 1 ? 's' : ''}.\n`
                if (updated > 0) message += `${updated} plato${updated !== 1 ? 's' : ''} actualizado${updated !== 1 ? 's' : ''}.\n`
                if (errors.length > 0) {
                    message += `${errors.length} plato${errors.length !== 1 ? 's' : ''} con error:\n`
                    errors.forEach(e => { message += `• ${e.name}: ${e.reason}\n` })
                }
                if (created === 0 && updated === 0 && errors.length === 0) {
                    message = 'El archivo no contenía platos para procesar.'
                }

                const hasSuccesses = created + updated > 0
                const hasErrors = errors.length > 0
                const icon = hasSuccesses && hasErrors ? 'warning' : hasErrors ? 'error' : 'success'

                await Swal.fire({
                    icon,
                    title: 'Importación completada',
                    text: message,
                })

                this.$router.go()

            } catch {
                await Swal.fire({
                    icon: 'error',
                    title: 'Error al importar',
                    text: 'No se pudo procesar el archivo. Verificá el formato e intentá nuevamente.',
                })
            } finally {
                this.uploading = false
            }
        },

    }
}

</script>

<template class="my-dishes">
    <Layout>
        <PageHeader />
        <div class="my-dishes-btn-container">
            <button v-if="canChangeCategory()" class="my-dishes-btn" v-show="!loading" @click="openSortCategories">
                Ordenar Categorías
            </button>
            <div v-if="canAddDish()" v-show="!loading">
                <router-link  to="/welly/my-dishes/create-dish"><button class="my-dishes-btn">
                        <img src="@/assets/images/add.svg" alt="add">
                        Agregar plato
                    </button>
                </router-link>
            </div>
            <button v-if="canAddDish()" class="my-dishes-btn" v-show="!loading" @click="openLoadDishes">
                <img src="@/assets/images/stats.png" />
                Importar platos
            </button>
            <button v-if="canDownloadTemplate()" class="my-dishes-btn" v-show="!loading" @click="downloadTemplate">
                <img src="@/assets/images/stats.png" style="transform: rotate(180deg);"/>
                Exportar platos
            </button>
        </div>
        <Loader v-show="loading" @loading="closeLoading" :loading="true"></Loader>
        <div v-show="!loading">
            <div v-for="(category, categoryIndex) in categories" :key="categoryIndex">
                <DishCardContainer :category="category" :categoryIndex="categoryIndex" @edit-dish="openEdit"
                    @delete-dish="openDeleteDishModal" @is-active-dish="openIsAsctiveDishModal" />
            </div>
        </div>
        <DeleteDishModal :dish="selectedDish" @delete-dish="(dish) => deleteDish(dish)" />
        <IsActiveDishModal :dish="selectedDish" />
        <DishCategorySort @sorted-categories="reloadDishes" />
        <b-modal id="loadDishes" centered size="lg" hide-footer>
            <div class="load-dishes">
                <p>Para cargar varios platos por primera vez descarga el archivo de
                    plantilla con formato XLSX <a href="#" @click.prevent="handleTemplateDownload">aquí</a>.</p>
                <p>Si ya tienes platos, agrega o modifica los existentes desde "Exportar Platos"</p>
            </div>
            <div class="file-upload-container text-center" v-if="!uploading">
                <input ref="fileInput" type="file" @change="handleFileSelection" accept=".xls, .xlsx"
                    style="display: none;" />
                <div class="mb-2">
                    <span v-if="selectedFileName">{{ selectedFileName }}</span>
                </div>
                <div>
                    <button type="button" class="file-upload-button" @click="handleFileAction">{{ selectedFileName ?
                        'Subir Archivo' : 'Cargar Archivo' }}</button>
                </div>
            </div>
            <div class="text-center" v-if="uploading">
                <Loader class="w-100 h-100 pb-5" :loading="true"></Loader>
            </div>
        </b-modal>
    </Layout>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/my-dishes/myDishes';
</style>